<template>
    <div class="flex max-w-[670px] mx-auto">
        <div class="w-[40px] h-[40px] mt-5 hidden lg:flex flex-shrink-0">
            <img 
                src="/images/campaigns/promo-arrow.svg"
                alt="Promo arrow"
            />
        </div>

        <div class="w-full select-none">
            <div class="promo p-2 sm:p-2.5 ml-2 flex flex-col rounded-md">
                <div 
                    class="flex justify-between items-center cursor-pointer" 
                    @click="expanded = !expanded">
                    <div class="flex items-center">
                        <p class="bg-[#F6C407] text-[13px] sm:text-[14px] text-white font-semibold rounded-md px-1 sm:px-2 py-1">
                            {{ $t('campaign_version_one.Promo') }}
                        </p>

                        <p class="text-[#D6AB0B] text-[13px] sm:text-[14px] ml-2">
                            <slot name="title" />
                        </p>
                    </div>

                    <div class="mx-2 duration-150 flex flex-shrink-0" :class="{'rotate-180': expanded}">
                        <img 
                            src="/images/campaigns/promo-down-arrow.svg"
                            alt="Promo down arrow"
                        />
                    </div>
                </div>

                <p v-if="expanded" class="text-[#D6AB0B] text-[13px] sm:text-[14px] pr-6 mt-3">
                    <slot />
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expanded: false,
        };
    },
};
</script>

<style scoped>
.promo {
    background-color: rgba(246, 196, 7, 0.2);
}
</style>